import React from 'react';
import {
  Button, Col, Form, Row, Spinner,
} from 'react-bootstrap';
import TextField from 'components/DesignSystem/TextField';
import './index.scss';

export default function SavePreferenceForm({
  valid,
  isLoading,
  onNameChange,
  handleSubmit,
}: {
  valid: boolean;
  isLoading: boolean;
  onNameChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSubmit: (event: React.FormEvent<HTMLFormElement>) => Promise<void>;
}) {
  return (
    <div>
      <Form onSubmit={handleSubmit}>
        <div className="preference-form-body">
          <Row className="justify-content-center">
            <Col className="text-center">
              Antes de salvar, dê um
              {' '}
              <b>nome</b>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col className="text-center">
              <p>para sua nova preferência.</p>
            </Col>
          </Row>
          <Row>
            <Col>
              <TextField required onInput={onNameChange} type="text" controlId="preferenceName" />
            </Col>
          </Row>
        </div>
        <Row className="justify-content-center preference-form-footer">
          <Col className="text-center">
            <Button
              type="submit"
              className={
                `text-nowrap mt-3
                ${valid ? 'primary-button' : 'secondary-button'}`
              }
              disabled={!valid}
            >
              {isLoading && <Spinner size="sm" />}
              Salvar nova preferência
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
}
